import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TelephoneInput from '../TelephoneInput';

const Header = styled.h4`
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: bold;
  font-family: inherit;
`;

const HeaderTag = styled.span`
  font-size: 0.875rem;
  color: #7a7a7a;
  font-weight: initial;
  margin: 0 0.25rem;
`;

const Description = styled.p`
  margin: 1rem auto;
  font-family: inherit;
`;

const Error = styled.p`
  margin: 0.25rem;
  font-size: 0.75rem;
  color: #e02020;
  text-align: left;
`;

const Footer = styled.p`
  margin: 1rem 0 0 0;
  font-size: 0.75rem;
  color: #7a7a7a;
`;

const PhoneNumberForm = ({
  onChange,
  onFocus,
  onBlur,
  value,
  header,
  headerTag,
  description,
  placeholder,
  error,
  errorMessage,
  footer,
}) => (
  <div data-test="phone-number-form">
    {header && (
      <Header>
        {header}
        {headerTag && <HeaderTag>{headerTag}</HeaderTag>}
      </Header>
    )}
    {description && <Description dangerouslySetInnerHTML={{ __html: description }} />}
    <TelephoneInput
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
    />
    {error && <Error dangerouslySetInnerHTML={{ __html: errorMessage }} />}
    {footer && <Footer dangerouslySetInnerHTML={{ __html: footer }} />}
  </div>
);

PhoneNumberForm.defaultProps = {
  onFocus: () => {},
  onBlur: () => {},
  header: '',
  headerTag: '',
  description: '',
  placeholder: '',
  footer: '',
  error: false,
  errorMessage: '',
};

PhoneNumberForm.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  header: PropTypes.string,
  headerTag: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  footer: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default PhoneNumberForm;
